/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 1b8b3abca32e2944b8fba3ab2fea012630968b0b
 */

/**
 * When the publisher payout for a rate is due.
 */
export type PaymentMoment = typeof PaymentMoment[keyof typeof PaymentMoment];


export const PaymentMoment = {
  progressive: 'progressive',
  upfront: 'upfront',
} as const;
